import { render } from "./GraphicElements.vue?vue&type=template&id=b27784a4&scoped=true"
import script from "./GraphicElements.vue?vue&type=script&lang=ts"
export * from "./GraphicElements.vue?vue&type=script&lang=ts"

import "./GraphicElements.vue?vue&type=style&index=0&id=b27784a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b27784a4"

export default script